// custo product upsell 
class ProductUpsell extends HTMLElement {
  constructor() {
    super();
  }
}
// Define the custom element
customElements.define('product-upsell', ProductUpsell);


// // custom accordion code 
class CustomAccordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const answer = this.querySelector('.answer');
        const question = this.querySelector('.question');

        question.addEventListener('click', () => {
            if (question.classList.contains('open')) {
                question.classList.remove('open');
                answer.style.maxHeight = null;
            } else {
                question.classList.add('open');
                answer.style.maxHeight = answer.scrollHeight + 'px';
            }
        });
    }
}

// Define the custom element
customElements.define('custom-accordian', CustomAccordion);
